import deleteSiteMeta from '../base-saving-actions/delete-site-meta';

const deleteFolders = (folderIds) =>
  [...folderIds].reduce(
    (saveActions, folderId) => [...saveActions, deleteSiteMeta(['folders', folderId])],
    []
  );

export default deleteFolders;
